import { Singleton } from 'typescript-ioc'
import { AbstractEntityService } from '@halo/services/abstract-entity.service'
import aqe from '@pushly/aqe'
import { IApiCallOptions, IPageAnalysisConfig } from '@pushly/aqe/lib/interfaces'

@Singleton
export class PageAnalysisConfigsService extends AbstractEntityService<IPageAnalysisConfig> {
    public async fetchAll(options: IApiCallOptions = {}) {
        return this.execFetchMany(`${aqe.defaults.publicApiDomain}/v3/page-analysis-configs`, options)
    }

    public async fetchById(id: number, options: IApiCallOptions = {}) {
        return this.execFetchOne(`${aqe.defaults.publicApiDomain}/v3/page-analysis-configs/${id}`, options)
    }

    public async create(createDto: Partial<IPageAnalysisConfig>) {
        return this.execCreate(`${aqe.defaults.publicApiDomain}/v3/page-analysis-configs/`, createDto)
    }

    public async patch(id: number, patchDto: Partial<IPageAnalysisConfig>) {
        return this.execPatch(`${aqe.defaults.publicApiDomain}/v3/page-analysis-configs/${id}`, patchDto)
    }

    public async delete(id: number) {
        return this.execDelete(`${aqe.defaults.publicApiDomain}/v3/page-analysis-configs/${id}`)
    }
}
